import reducer from './reducers';
import * as collectionSearchResultTypes from './types';

export { collectionSearchResultTypes };
export default reducer;
